module.exports = __webpack_public_path__ + "static/media/Foodtopia_desktop.fb9bc55a.jpg";